import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

import useTracking from 'containers/Player/hooks/useTracking';

const TrackingContext = createContext({});

const TrackingProvider = ({ children }) => {
  const [deviceId, setDeviceId] = useState(null);
  const [groupId, setGroupId] = useState(null);

  const {
    handleInitTracking,
    handleStart,
    handlePause,
    handleTick,
    handleError,
    handleSeek,
    handleSubChange,
    handleCredits,
    handleEnd,
    handleStop,
    handleEpisodeChange,
    handleResume,
  } = useTracking(deviceId, groupId);

  const handleSetDeviceId = _deviceId => setDeviceId(_deviceId)

  const handleSetGroupId = _groupId => setGroupId(_groupId)

  return (
    <TrackingContext.Provider
      value={{
        handleInitTracking,
        handleSetDeviceId,
        handleSetGroupId,
        handleStart,
        handlePause,
        handleTick,
        handleError,
        handleSeek,
        handleSubChange,
        handleCredits,
        handleEnd,
        handleStop,
        handleEpisodeChange,
        handleResume,
      }}
    >
      {children}
    </TrackingContext.Provider>
  );
};

TrackingProvider.propTypes = {
  children: PropTypes.node,
};

export { TrackingProvider, TrackingContext };
